import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 8,
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 8,
			width: 24,
			height: 8,
			fill: "#DD0000"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 16,
			width: 24,
			height: 8,
			fill: "#FFCE00"
		})
	]
});
export default SvgDe;
